import React from "react";
import PropTypes from "prop-types";
import { intlShape } from "react-intl";
import { COLORS } from "./constants";
import { LINK_COLOR } from "./constants";
import StandardMoney from "../../../common/StandardMoney";

const legendStyle = {
  width: "260px",
  marginLeft: "auto",
  marginRight: "auto",
  lineHeight: "1.8em",
  listStyleType: "none",
};

const PieLegent = ({ categories, currencyCode, intl }) => {
  return (
    <ul style={legendStyle}>
      {categories.map((item, idx) => {
        return (
          <li key={item.categoryName}>
            <span
              style={{
                paddingLeft: "20px",
                marginRight: "10px",
                backgroundColor: Number(item.entitlement) > 0 ? COLORS[idx] : "transparent",
                width: "20px",
              }}
            />
            <a style={{ color: LINK_COLOR }} href={`#${item.categoryName}`}>
              {intl.formatMessage({
                id: item.categoryName,
                defaultMessage: item.categoryName,
              })}
            </a>
            <br />
            {Number(item.entitlement) > 0 && (
              <span style={{ paddingLeft: "30px", color: "black", fontSize: "0.875em" }}>
                <StandardMoney value={item.entitlement} currency={currencyCode} />
              </span>
            )}
          </li>
        );
      })}
    </ul>
  );
};

PieLegent.propTypes = {
  categories: PropTypes.array,
  currencyCode: PropTypes.string,
  intl: intlShape.isRequired,
};

export default PieLegent;



// WEBPACK FOOTER //
// ./components/employee/benefits/trs/PieLegend.jsx